import NeedHelp from 'core/components/NeedHelp';
import PageBanner from 'core/components/PageBanner/index';
import ServiceDescription from 'core/components/ServiceDescription';
import TableSkeleton from 'core/components/skeleton';
import { TableWithUnits } from 'core/components/Table';
import Images from 'core/data/constants/Images';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './styles.css';
import { AbstractDryCleaningRemoteDataSource } from 'features/dryCleaning/data/remote/Abstract_dry_cleaning_remote_data_source';
import { DryCleaningRemoteDataSource } from 'features/dryCleaning/data/remote/Dry_cleaning_remote_data_source';
import { SewingModel } from 'features/sewing/data/models/SewingModel';
import MotionDiv from 'core/components/Motion';

export const DryCleaning = () => {
  const { t } = useTranslation();
  const [dryCleaning, setDryCleaning] = useState<SewingModel[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const dryCleaningRemoteDataSource: AbstractDryCleaningRemoteDataSource = new DryCleaningRemoteDataSource();
      try {
        const response = await dryCleaningRemoteDataSource.getDryCleaning();
        setDryCleaning(response.success ? response.data : []);
      } catch (error) {
        // console.error("API error:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="mainIroning pageBody">
      <PageBanner imagePath={Images.DryCleaningImage} title={t('dry_cleaning')} />
      <div className="content">
        <MotionDiv className="contentDescription" viewport={{ amount: 0 }} initial={{ opacity: 0, x: -40 }}>
          <ServiceDescription title="dry_cleaning" description="ironing_description" />
          <NeedHelp />
        </MotionDiv>

        <div className="table">
          <div id="washAndIronTableSection">
            <MotionDiv viewport={{ once: true, amount: 0 }}>
              <h1>{t('dry_cleaning')}</h1>
              {dryCleaning.length ? (
                <TableWithUnits columnNames={[t('default_article'), t('default_price')]} data={dryCleaning} />
              ) : (
                <TableSkeleton columnNames={[t('default_article'), t('default_price')]} />
              )}

            </MotionDiv>
          </div>
        </div>
      </div>
      <div className='footerSeperator'>
      </div>
    </div>
  );
};

export default DryCleaning;
